const checkDeleteCompanyCallFormService = {
  confirm: 'Do you really want to delete this service? All Actions related to this service will be deleted',
  title: 'DELETE SERVICE'
};

export default checkDeleteCompanyCallFormService;
